//import { businessInsightsHandlers } from "./businessInsightsHandlers";
import { generalHandlers } from "./generalHandlers";

export const discussionHandlerMap = {
  actionItems: generalHandlers,
  businessInsights: generalHandlers,
  //businessInsights: businessInsightsHandlers,
  activityNotes: generalHandlers,
  forecaster: generalHandlers,
  manualExpense: generalHandlers,
  dataAccuracy: generalHandlers,
};
